import { c as _c } from "react/compiler-runtime";
import * as RadixDialog from '@radix-ui/react-dialog';
import { cx } from 'class-variance-authority';
import { AnimatePresence, motion } from 'framer-motion';
import { forwardRef } from 'react';
import Overlay from '../overlay';
import DrawerFooter from './components/footer/footer';
import DrawerHeader from './components/header/header';
import type { DrawerProps } from './drawer.types';
const Drawer = forwardRef<HTMLDivElement, DrawerProps>((t0, ref) => {
  const $ = _c(30);
  const {
    children,
    defaultOpen,
    isNested,
    linkButton,
    onBack,
    onClickOutside,
    onClose,
    onEscapeKeyDown,
    onOpenChange,
    preventEscapeKeyDown,
    open: t1,
    primaryButton,
    secondaryButton,
    size: t2,
    subHeaderComponent,
    hideOverlay: t3,
    portalElement,
    title,
    headerTooltip
  } = t0;
  const open = t1 === undefined ? false : t1;
  const size = t2 === undefined ? "default" : t2;
  const hideOverlay = t3 === undefined ? false : t3;
  const shouldRenderFooter = !!primaryButton || !!secondaryButton || !!linkButton;
  let t4;
  if ($[0] !== onClose || $[1] !== onEscapeKeyDown || $[2] !== preventEscapeKeyDown) {
    t4 = event => {
      if (preventEscapeKeyDown) {
        event.preventDefault();
      } else {
        if (onEscapeKeyDown) {
          event.preventDefault();
          onEscapeKeyDown();
        } else {
          onClose();
        }
      }
    };
    $[0] = onClose;
    $[1] = onEscapeKeyDown;
    $[2] = preventEscapeKeyDown;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleEscapeKeyDown = t4;
  let t5;
  if ($[4] !== children || $[5] !== handleEscapeKeyDown || $[6] !== headerTooltip || $[7] !== hideOverlay || $[8] !== isNested || $[9] !== linkButton || $[10] !== onBack || $[11] !== onClickOutside || $[12] !== onClose || $[13] !== open || $[14] !== portalElement || $[15] !== primaryButton || $[16] !== ref || $[17] !== secondaryButton || $[18] !== shouldRenderFooter || $[19] !== size || $[20] !== subHeaderComponent || $[21] !== title) {
    t5 = open && <RadixDialog.Portal forceMount={true} container={portalElement}><RadixDialog.Content aria-describedby={undefined} asChild={true} onEscapeKeyDown={handleEscapeKeyDown} onPointerDownOutside={onClickOutside || onClose}><motion.div ref={ref} initial={{
          opacity: 0,
          x: 100
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: 100
        }} transition={{
          duration: 0.1
        }} className={cx("\n                  fixed flex flex-col overflow-hidden\n                  border border-solid border-tertiary\n                  bg-primary shadow-lg\n                  z-drawer inset-1  \n                  w-auto rounded\n                  sm:inset-3 sm:left-auto\n                  focus-visible:outline-none\n                ", {
          "sm:w-[500px]": size === "default",
          "sm:w-[800px]": size === "large"
        })}><DrawerHeader title={title} isNested={isNested} onBack={onBack} onClose={onClose} headerTooltip={headerTooltip} />{subHeaderComponent}<div className="overflow-auto relative flex-1 max-w-full"><AnimatePresence mode="wait" initial={false}><motion.div initial={{
                opacity: 0,
                x: isNested ? 100 : -100
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: isNested ? 100 : -100
              }} transition={{
                duration: 0.1
              }} key={isNested ? "nested" : "main"} className="absolute inset-0 p-4">{children}</motion.div></AnimatePresence></div><AnimatePresence initial={false}>{shouldRenderFooter && <DrawerFooter primaryButton={primaryButton} secondaryButton={secondaryButton} linkButton={linkButton} isNested={isNested} />}</AnimatePresence></motion.div></RadixDialog.Content><RadixDialog.Overlay asChild={true}>{hideOverlay ? null : <Overlay isVisible={open} isConfirmation={false} />}</RadixDialog.Overlay></RadixDialog.Portal>;
    $[4] = children;
    $[5] = handleEscapeKeyDown;
    $[6] = headerTooltip;
    $[7] = hideOverlay;
    $[8] = isNested;
    $[9] = linkButton;
    $[10] = onBack;
    $[11] = onClickOutside;
    $[12] = onClose;
    $[13] = open;
    $[14] = portalElement;
    $[15] = primaryButton;
    $[16] = ref;
    $[17] = secondaryButton;
    $[18] = shouldRenderFooter;
    $[19] = size;
    $[20] = subHeaderComponent;
    $[21] = title;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t5) {
    t6 = <AnimatePresence>{t5}</AnimatePresence>;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== defaultOpen || $[26] !== onOpenChange || $[27] !== open || $[28] !== t6) {
    t7 = <RadixDialog.Root open={open} onOpenChange={onOpenChange} defaultOpen={defaultOpen}>{t6}</RadixDialog.Root>;
    $[25] = defaultOpen;
    $[26] = onOpenChange;
    $[27] = open;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
});
Drawer.displayName = 'Drawer';
export default Drawer;